<template>
  <div class="list shad">
    <div>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div></div>
        <div class="btn-group" role="group" style="float:right" aria-label="Basic example">
          <button type="button" class="btn" :class="{ 'btn-secondary': type === 'bullet' }" @click="type='bullet'"><strong><em><font-awesome-icon :icon="['far', 'list-ul']" /></em></strong></button>
          <button type="button" class="btn" :class="{ 'btn-secondary': type === 'ordered' }" @click="type='ordered'"><font-awesome-icon :icon="['far', 'list-ol']" /></button>
        </div>
        <div></div>
      </div>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <editable-title 
          v-model.trim="title"
          style="width:100%"
          >
        </editable-title>
      </div>
      <transition name="fade">
        <div v-if="show === true">
      <ol v-if="type==='ordered'">
        <li v-for="(item, index) in items" :key="item.id" class="m-2">
          <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center">
            <single-line-input 
              :value="item.value" 
              :index="index"
              :active="item.editState === 'focus'"
              @input="updateItem(index, $event)"
              @item-focus="setItemFocus(index)"
              @item-blur="setItemBlur(index)"
              style="width:100%"
            ></single-line-input>
            <transition name="fade">
            <button @click.prevent="deleteItem(index)" class="deletebutton" v-show="item.editState === 'focus'">
              <font-awesome-icon 
                :icon="['far', 'minus-circle']" 
                style="font-size:30;cursor:pointer" 
              />
            </button>
            </transition>
          </div>
        </li>
      </ol>
      <ul v-else>
        <li v-for="(item, index) in items" :key="item.id" class="m-2">
          <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center">
            <single-line-input 
              :value="item.value" 
              :index="index"
              @input="updateItem(index, $event)"
              @item-focus="setItemFocus(index)"
              @item-blur="setItemBlur(index)"
              @delete-item="deleteItem(index)"
              style="width:100%"
            ></single-line-input>
            <transition name="fade">
            <button @click.prevent="deleteItem(index)" class="deletebutton" v-show="item.editState === 'focus'">
              <font-awesome-icon 
                :icon="['far', 'minus-circle']" 
                style="font-size:30;cursor:pointer" 
              />
            </button>
            </transition>
          </div>
        </li>
      </ul>
      </div>
      </transition>
      <b-container class="mt-4 mb-4">
        <b-row>
          <b-col><div class="mb-2 p-2 addbutton"  @click="addNewItem"><font-awesome-icon :icon="['far', 'plus-circle']" style="font-size:30" /></div></b-col>
        </b-row>
      </b-container>
      <div class="notebox" style="">
        <note-editor :value="{ noteId: id, note: note}" @input="updateNote($event)" />
      </div>
      <!-- <div class="mt-5">
          <pre>{{ listData }}</pre>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapFields, mapMultiRowFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex'
import NoteEditor from '@/components/NoteEditor'
import EditableTitle from '@/components/EditableTitle'
import SingleLineInput from '@/components/SingleLineInput'
// import { Person } from "blockstack";
// import { userSession } from "../userSession";
import { EventBus } from '@/event-bus';
import store from '@/store/store'
import NProgress from 'nprogress'

export default {
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapFields([
      'listData',
      'listData.id',
      'listData.title',
      'listData.type',
      'listData.showNote',
      'listData.note',
      'listData.createdAt',
      'blockstack.user',
      'blockstack.userSession',
      'blockstack.user.username'
    ]),
    ...mapMultiRowFields(['listData.items']),
    ...mapGetters(['listsCount']),
    needsSave () {
      return this.$store.getters.needsSave
    },
    needsSave_currentList () {
      return this.$store.getters.needsSave_currentList
    },
    needsSave_lists () {
      return this.$store.getters.needsSave_lists
    },
  },
  created() {

    this.$store.dispatch('setUserSession')
    EventBus.$on('new-clicked', this.new);
    EventBus.$on('save-clicked', this.save);
    EventBus.$on('print-clicked', this.print);
    // EventBus.$on('menu-clicked', this.showNewNote);
    EventBus.$on('delete-clicked', this.delete);
    EventBus.$on('switch-list', this.switchList);
  },
  mounted() {
    console.log("[List] Local mounted - checking for blockstack")
    // this.$store.dispatch('checkAndFinishSignIn')

    if (this.userSession.isUserSignedIn()) {
      // console.log("user is signed in");
      this.$store.dispatch('setUserProperties').then(() => {
        this.$store.dispatch('loadLists')
      })
      
    } else if (userSession.isSignInPending()) {
      // console.log("signinpending")
      this.userSession.handlePendingSignIn().then(userData => {
        // console.log("user pending log in finished");
        this.$store.dispatch('loadLists')
        window.location = window.location.origin
      });
    } else {
      // console.log("No user signed in")
      this.$router.push('/login')
    }

    // console.log("[List] mounted, with param: ", this.$route.params.id);
    // console.log('enabling toolbar')
    this.$store.commit('SET_ENABLETOOLBAR', true)

    console.log('showing')
    this.show = true
  },
  methods: {
    addNewItem() {
      this.$store.commit('ADD_NEW_ITEM')
    },
    updateItem(index, newValue) {
      this.$store.commit('UPDATE_ITEM', { index, newValue })
      // this.$store.dispatch('saveIfNeeded')
    },
    updateNote(newValue) {
      if (this.note != newValue) {
        this.$store.commit('UPDATE_NOTE', newValue)
      }
    },
    setItemFocus(index) {
      this.$store.commit('SET_ITEM_FOCUS', index)
    },
    setItemBlur(index) {
      this.$store.commit('SET_ITEM_BLUR', index)
    },
    deleteItem(index) {
      this.$store.commit('DELETE_ITEM', index)
    },
    new () {
      this.$router.push('/new').catch(err => {})
    },
    save () {
      // console.log('running save')
      this.$store.commit('SET_LIST_SAVING', true)
      NProgress.start()
      var listId = this.id
      var isNewList = this.createdAt === null
      this.$store.dispatch('save')
        .then(() => {
          if (isNewList) {
            this.$router.push('/lists/' + listId)
          } else {
            // console.log('not new list, continue...')
          }
        })
        .finally(() => {
          this.$store.commit('SET_LIST_SAVING', false)
          NProgress.done()
        })
    },
    print () {
      window.print()
      // console.log('needsSave is :', this.$store.getters.needsSave)
      // console.log('needsSave_currentList is :', this.$store.getters.needsSave_currentList)
      // console.log('needsSave_lists: ', this.$store.getters.needsSave_lists)
    },
    delete () {
      console.log('delete')
      // alert('delete coming soon!')
      this.$store.commit('SET_LIST_DELETING', true)
      this.$store.dispatch('deleteCurrentList')
        .then(() => {
          // this route will generate a new list if necessary
          this.$store.commit('SET_LIST_DELETING', false)
          this.$router.push('/lists')
        })
        .catch(() => {
          this.$store.commit('SET_LIST_DELETING', false)
        })
    },
    switchList (listIndex) {
      const listId = this.$store.state.lists[listIndex].id
      this.$router.push('/lists/' + listId).catch(err => {})
    }
  },
  components: {
    NoteEditor,
    EditableTitle,
    SingleLineInput
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Lexend+Deca&display=swap');

h1 {
  /* font-family: 'Lexend Deca', sans-serif; */
}

.list {
  background-color: white;
  border-radius: 15px;
  padding: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  margin: 0px
}

.shad {
  -webkit-box-shadow: 6px 6px 5px black;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  -moz-box-shadow:    6px 6px 5px black;  /* Firefox 3.5 - 3.6 */
  box-shadow:         6px 6px 5px black;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}

li {
  font-size:32px;
}
li div {
  font-size:32px;
  /* font-weight:450; */
  /* font-family: 'Lexend Deca', sans-serif; */
}

.listitem {
  /* border: 1px dotted gray; */
}

.addbutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
  background-color: whitesmoke;
}

.addbutton:hover {
  background-color: lightgray;
}

.notebutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
}

.notebutton:hover {
  background-color: whitesmoke;
}

.notebox {
  
  margin-left:-10px;
  margin-right:-10px
}

.active {
  background: green;
  border: 1px dotted blue;
  display:inline;
}

.sli:hover + .deletebutton {
  display: block
}

.deletebutton {
    background-color:transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    width:40px;
    height:100%;
    margin-left: 5px;
    /* display:none; */
    /* border:1px solid gray; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (min-width: 500px) {

    .list {
      background-color: white;
      border-radius: 15px;
      padding: 50px;
      margin: 15px
    }

    .notebox {
      margin-left: 0px
    }
}

</style>